import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtUser, MtTask } from "server/models"
import {
    StoreType,
    setTaskDelegateSelected,
} from "client/store"
import {
    UserIcon,
    TableColumn,
} from "client/components"

const Columns = (task: MtTask) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectUser = (user: MtUser) => {
        dispatch(setTaskDelegateSelected([user.id]))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            onClick: selectUser,
        },
        {
            field: "firstName",
            header: lang.name,
            sortable: true,
            cellMinWidth: "250px",
            formatter: (user: MtUser) => (
                <UserIcon
                    user={user}
                    size="sm"
                    projectId={task.projectId}
                    showProjectStatus
                />
            ),
            onClick: selectUser,
        },
        {
            field: "status",
            header: lang.status,
            centerAlign: true,
            sortable: true,
            editAccess: () => false,
        },
    ]

    return columns
}
export default Columns
